import { render, staticRenderFns } from "./TodayCustomerTask.vue?vue&type=template&id=7b665ed1&"
import script from "./TodayCustomerTask.vue?vue&type=script&lang=js&"
export * from "./TodayCustomerTask.vue?vue&type=script&lang=js&"
import style0 from "./TodayCustomerTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports